
import { PageContainer } from 'app/shared/misc/PageContainer';
import { Spinner } from 'app/shared/misc/Spinner';

export const PageLoader = () => {
  return (
    <PageContainer className="items-center">
      <Spinner variant="white" size="medium" />
    </PageContainer>
  );
};
